import React, { useState } from 'react';

const Reservations: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '2',
    message: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('Reservation request:', formData);
    // Here you would send the data to your backend
    setFormSubmitted(true);
    
    // Reset the form after 3 seconds
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        guests: '2',
        message: '',
      });
    }, 3000);
  };

  return (
    <div className="min-h-screen pt-20 pb-16 bg-tuktuk-beige bg-opacity-20">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-display font-bold text-center text-tuktuk-brown mb-4">
          Book a Table
        </h1>
        <p className="text-center max-w-2xl mx-auto mb-12 text-lg">
          Reserve a table at Tuk Tuk Restaurant for an unforgettable culinary experience in Siem Reap.
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="md:flex">
              {/* Information section */}
              <div className="md:w-1/2 bg-tuktuk-brown p-8 text-white">
                <h2 className="text-2xl font-display font-bold mb-6">Reservation Policy</h2>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Reservations can be made up to 2 hours before arrival, subject to availability.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>For groups larger than 8 people, please contact us by phone.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Special dietary requests can be made in the comments field.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Cancellations must be made at least 2 hours in advance.</span>
                  </li>
                </ul>

                <h3 className="text-xl font-display font-bold mt-8 mb-4">Contact Information</h3>
                <p className="mb-2">Phone: +81 70-4476-1574</p>
                <p>Email: reservations@tuktukrestaurant.com</p>
              </div>

              {/* Reservation form */}
              <div className="md:w-1/2 p-8">
                {formSubmitted ? (
                  <div className="h-full flex items-center justify-center">
                    <div className="text-center">
                      <svg className="w-16 h-16 text-green-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <h3 className="text-2xl font-display font-bold text-tuktuk-green mb-2">Thank you for your reservation!</h3>
                      <p className="text-gray-600">We have received your request and will confirm it as soon as possible.</p>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Name</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <div>
                        <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                        />
                      </div>
                      <div>
                        <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Phone Number</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                      <div>
                        <label htmlFor="date" className="block text-gray-700 font-medium mb-2">Date</label>
                        <input
                          type="date"
                          id="date"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                        />
                      </div>
                      <div>
                        <label htmlFor="time" className="block text-gray-700 font-medium mb-2">Time</label>
                        <input
                          type="time"
                          id="time"
                          name="time"
                          value={formData.time}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                        />
                      </div>
                      <div>
                        <label htmlFor="guests" className="block text-gray-700 font-medium mb-2">Number of Guests</label>
                        <select
                          id="guests"
                          name="guests"
                          value={formData.guests}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                            <option key={num} value={num}>{num}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mb-6">
                      <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Special Requests</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={3}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tuktuk-brown"
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-tuktuk-red hover:bg-red-700 text-white font-bold py-3 px-6 rounded-md transition duration-300"
                    >
                      Request Reservation
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reservations; 